import React from 'react';

export function ArrowIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M3 8h9.2M8.8 4.2 13.5 8l-4.7 3.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M8 11V8.2A4 4 0 0 1 12 4a4 4 0 0 1 4 4.2V11"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function TaskPlayIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M8 5v14l11-7L8 5z" />
    </svg>
  );
}

export function PlayBadgeIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="var(--badge-fill, currentColor)" />
      <path
        d="M9.6 7.9v8.2c0 .62.67 1 1.2.68l6.55-4.1a.8.8 0 0 0 0-1.36L10.8 7.22a.8.8 0 0 0-1.2.68z"
        fill="var(--badge-mark, #ffffff)"
      />
    </svg>
  );
}

export function CheckBadgeIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="var(--badge-fill, currentColor)" />
      <path
        d="M7.4 12.3 10.4 15.2 16.6 8.9"
        stroke="var(--badge-mark, #ffffff)"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ReviewIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3.15" y="3.15" width="17.7" height="17.7" rx="4.25" fill="currentColor" />
      <path
        d="M7.55 12.2 10.45 15.2 16.55 8.95"
        stroke="var(--review-mark, #e7f7f2)"
        strokeWidth="1.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TargetArrowIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M18.99 10.09A8.5 8.5 0 1 1 13.91 5.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="11" cy="13" r="4.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="11" cy="13" r="1.3" fill="currentColor" />
      <path
        d="M11 13 15.5 8.5M15.5 5.5v3h3l3-3h-3v-3z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ChevronRightIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M6 3.6 11.2 8 6 12.4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
